<div class="chip-content static-chip">
	<div class="chip-details">
		<p-avatar
			[image]="crew.user?.avatar || crew.user?.imageUrl"
			[label]="(!crew.user?.avatar && !crew.user?.imageUrl) ? (name?.charAt(0) | uppercase) : ''"
			shape="circle"
			styleClass="crew-avatar"
			[style]="{'width': '1.5rem', 'height': '1.5rem', 'background-color': (!crew.user?.avatar && !crew.user?.imageUrl) ? '#c9ffa97d' : undefined, 'color': '#333'}"
		>
		</p-avatar>

		<span class="name">
			{{ name }}
		</span>

		<div
			class="chip-icons"
			*ngIf="showIcons"
		>
			<span
				class="icon"
				*ngIf="isLead"
			>
				<i
					class="pi pi-star-fill"
					style="color: var(--primary-color)"
				></i>
			</span>
			<span
				class="icon"
				*ngIf="isDriver"
			>
				<i class="pi pi-steering-wheel pi-custom"></i>
			</span>
		</div>
	</div>
</div>